const getTraitsDifferences = (
  initialTraits: Record<string, number>,
  newTraits: Record<string, number>,
): TraitDifferences => {
  let traitsDifferences: TraitDifferences = {
    from: {},
    to: {},
  };
  const initialTraitsKeys = Object.keys(initialTraits);
  const newTraitsKeys = Object.keys(newTraits);

  initialTraitsKeys.forEach((initialTraitsKey) => {
    if (newTraitsKeys.includes(initialTraitsKey)) {
      if (initialTraits[initialTraitsKey] !== newTraits[initialTraitsKey]) {
        traitsDifferences.from[initialTraitsKey] = initialTraits[initialTraitsKey];
        traitsDifferences.to[initialTraitsKey] = newTraits[initialTraitsKey];
      }
    } else {
      traitsDifferences.from[initialTraitsKey] = initialTraits[initialTraitsKey];
      traitsDifferences.to[initialTraitsKey] = null;
    }
  });

  newTraitsKeys.forEach((newTraitsKey) => {
    if (!initialTraitsKeys.includes(newTraitsKey)) {
      traitsDifferences.from[newTraitsKey] = null;
      traitsDifferences.to[newTraitsKey] = newTraits[newTraitsKey];
    }
  });
  return traitsDifferences;
};

const getFacialFeatureTraitsDifferences = (
  initialTraits: Record<string, string>,
  newTraits: Record<string, string>,
): FacialFeatureTraitDifferences => {
  let traitsDifferences: FacialFeatureTraitDifferences = {
    from: {},
    to: {},
  };
  const initialTraitsKeys = Object.keys(initialTraits);
  const newTraitsKeys = Object.keys(newTraits);

  initialTraitsKeys.forEach((initialTraitsKey) => {
    if (newTraitsKeys.includes(initialTraitsKey)) {
      if (initialTraits[initialTraitsKey] !== newTraits[initialTraitsKey]) {
        traitsDifferences.from[initialTraitsKey] = initialTraits[initialTraitsKey];
        traitsDifferences.to[initialTraitsKey] = newTraits[initialTraitsKey];
      }
    } else {
      traitsDifferences.from[initialTraitsKey] = initialTraits[initialTraitsKey];
      traitsDifferences.to[initialTraitsKey] = null;
    }
  });

  newTraitsKeys.forEach((newTraitsKey) => {
    if (!initialTraitsKeys.includes(newTraitsKey)) {
      traitsDifferences.from[newTraitsKey] = null;
      traitsDifferences.to[newTraitsKey] = newTraits[newTraitsKey];
    }
  });
  return traitsDifferences;
};

export default {
  getTraitsDifferences,
  getFacialFeatureTraitsDifferences,
};
